import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';

import CheckoutForm from './CheckoutForm';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);


// Make sure to call `loadStripe` outside of a component's render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe('pk_test_dgpwUgihbx2xhRT7OhvYnZTO');

class Stripe extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isShowStatus: false,
			statusType: null,
		}
	}

	componentWillReceiveProps(props) {
		console.log('componentWillReceiveProps', props)
	}
	

	render() {
		return (
			<Elements stripe={stripePromise}>
				<CheckoutForm />
			</Elements>
		);
	}
}

export default withRouter(Stripe);


// WEBPACK FOOTER //
// ./src/components/Stripe/Stripe.js